import { Paper, Skeleton, Stack, Typography } from "@mui/material";
import { ChartNoDataOverlay } from "../../../../../../../components/charts/components/ChartNoDataOverlay";
import { WaterfallChart } from "../../../../../../../components/charts/graph/WaterfallChart";
import { WaterfallKey } from "../../../../../../../components/charts/graph/WaterfallChart/data";
import { RootCauseWidgetWaterfallDTO } from "../../../../../../../datasources/api-client/data-contracts";

interface WaterfallProps {
	title: string;
	isLoading: boolean;
	data: RootCauseWidgetWaterfallDTO;
	labels: Record<WaterfallKey, string>;
}

export const Waterfall = ({ title, isLoading, data, labels }: WaterfallProps) => {
	if (isLoading) {
		return (
			<Paper sx={{ flex: 1 }} elevation={0}>
				<Skeleton variant="rounded" height={350} width="100%" />
			</Paper>
		);
	}

	return (
		<Paper elevation={0} sx={{ p: 2 }}>
			<Stack gap={1}>
				<Typography variant="h6" color="primary">
					{title}
				</Typography>
				<WaterfallChart data={data} labels={labels} noDataOverlay={<ChartNoDataOverlay />} />
			</Stack>
		</Paper>
	);
};
